import reducer from './reducers';
import * as leadActions from './actions';

export { leadActions };
export default reducer;
